import { hashString } from "./hashString";
export const getEffectKey = (fn, deps) => {
    const key = hashString(`${fn.toString()}-${JSON.stringify(deps.map((i) => typeof i))}`).toString();
    return key;
};
//# sourceMappingURL=getEffectKey.js.map